import AgreementPage from "../../pages/AgreementPage/AgreementPage";

export enum PATHS {
    SHOP = "/",
    SHOPLITE = "/lite",
    SHOPNASDARA = "/nasdara",
    DEPOSIT = "/deposit",
    AGREEMENT = "/agreement",
    PRIVACY = "/privacy",
    CUSTOM = "/custom",
    LOGOUT = "/logout",
    LOGIN = "/auth/steam/",
    PROFILE = "/profile",
    ABOUT = "/about",
    SETTINGS = "/settings",
    MAP = "/map",
    STATS = "/stats"
}

export enum URL {
    FRONT = "http://localhost:5173/",
    BACKEND = "http://localhost:5000/",
}